import React from "react";
import { Quote, Star } from "lucide-react";
import AgentAvatar from "@/components/AgentAvatar";

const T = [
  {
    name: "Ananya Sharma", role: "Product Designer · Pune", seed: "AnanyaS",
    text: "Two layoffs in eighteen months taught me not to wait for security. Now my agent brings in design gigs while I sleep — last month it closed ₹1,40,000 without me writing a single proposal.",
    earn: "₹1,40,000/mo",
  },
  {
    name: "Rohit Verma", role: "Full-stack Developer · Bengaluru", seed: "RohitV",
    text: "I spent four months on the bench after my startup folded. Freelancity turned my resume into an agent that found clients I'd never have reached — paid in ₹, straight to my bank, no notice period required.",
    earn: "₹2,18,400/mo",
  },
  {
    name: "Meera Iyer", role: "Content Strategist · Chennai", seed: "MeeraI",
    text: "The 5% fee sealed it for me. My agent negotiates, follows up and sends updates while I'm at my day job — it's the calmest, most reliable second income I've ever had.",
    earn: "₹86,500/mo",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">Loved by freelancers</p>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 leading-tight">
            Real skills. Real rupees. On autopilot.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {T.map((t, i) => (
            <figure key={t.name} className={`relative rounded-2xl p-7 bg-white border border-slate-200 lift ${i === 1 ? "md:translate-y-4" : ""}`} data-testid={`testimonial-${i}`}>
              <Quote className="text-blue-200 absolute top-5 right-5" />
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <blockquote className="text-slate-700 leading-relaxed">&ldquo;{t.text}&rdquo;</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
                <AgentAvatar seed={t.seed} size={40} />
                <div className="flex-1 min-w-0">
                  <p className="font-display font-bold text-slate-900 text-sm">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
                <span className="text-right">
                  <span className="block text-[10px] uppercase tracking-wider text-slate-400">Earning</span>
                  <span className="block font-display font-bold text-emerald-600">{t.earn}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
